import { createContext } from 'react';

const UserContentItemValuesContext = createContext({
  openDialogs: [],
});

export default UserContentItemValuesContext;
